var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-container"},[_c('car-drive',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLogo),expression:"!showLogo"}]}),_c('custom-video'),_c('about-us',{attrs:{"id":"aboutUs"}}),_c('centered-auto-swiper',{attrs:{"scroll-y":_vm.scrollY,"aboutUsHeight":_vm.aboutUsHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }